{
  "unauthorized": {
    "errorCode": "403",
    "title": "Tillgång nekad",
    "subtitle": "Du har inte behörighet att komma åt denna sida.",
    "backToChat": "Gå till chatt",
    "helpText": "Om du tror att detta är ett fel, vänligen kontakta din organisationsadministratör."
  },
  "missionChat": {
    "agentNotRespondingDescription": "Värden \"{{hostName}}\" är ansluten, men agentens körmiljö svarar inte. Kontrollera att agentprogrammet körs på värden.",
    "hostOfflineDescription": "Agentvärden \"{{hostName}}\" är offline just nu.",
    "accessDenied": "Åtkomst nekad",
    "accessDeniedDescription": "Du har inte behörighet att öppna det här uppdraget.",
    "agentNotResponding": "Agenten svarar inte",
    "agentNotRespondingHint": "Kontrollera att agion-sdk-agenten körs och lyssnar på port 8190.",
    "connectionError": "Anslutningsfel",
    "connectionErrorDescription": "Det gick inte att ansluta till uppdraget.",
    "error": "Något gick fel",
    "hostNotFound": "Värden är inte tillgänglig",
    "hostNotFoundDescription": "Agentvärden för det här uppdraget hittades inte.",
    "hostOffline": "Värden är offline",
    "hostOfflineHint": "Kontrollera att agentvärden körs och är ansluten till VPN.",
    "loadingHost": "Ansluter till värden...",
    "notFoundDescription": "Det här uppdraget finns inte eller kan ha tagits bort.",
    "retry": "Försök igen",
    "retryConnection": "Anslut igen",
    "launching": "Startar...",
    "runMission": "Kör uppdrag",
    "loading": "Laddar missionschatt...",
    "notFound": "Mission hittades inte",
    "loadError": "Kunde inte ladda mission"
  },
  "files": {
    "title": "Filer",
    "subtitle": "Hantera dina uppladdade filer och data",
    "searchPlaceholder": "Sök filer...",
    "count_one": "{{count}} fil",
    "count_other": "{{count}} filer",
    "loading": "Laddar filer...",
    "noFilesFound": "Inga filer hittades",
    "noFilesUploaded": "Inga filer uppladdade",
    "adjustSearch": "Prova att justera din sökning",
    "uploadFirst": "Ladda upp din första fil för att komma igång",
    "deleteConfirm": "Är du säker på att du vill radera denna fil?",
    "deleteSuccess": "Fil raderad",
    "fileRemoved": "Fil borttagen",
    "deleteError": "Kunde inte radera filen",
    "downloadError": "Kunde inte ladda ner filen",
    "downloadSuccess": "Fil nedladdad",
    "clickToRename": "Klicka för att byta namn på fil",
    "referenceHint": "Filer med status 'slutförd' kan refereras i chatten",
    "columnName": "Namn",
    "columnSize": "Storlek",
    "columnDate": "Uppladdad",
    "columnStatus": "Status",
    "time": {
      "justNow": "Just nu",
      "minutesAgo": "{{count}}m sedan",
      "hoursAgo": "{{count}}h sedan",
      "daysAgo": "{{count}}d sedan"
    }
  },
  "agents": {
    "title": "Agenter",
    "subtitle": "Välj en agent för att starta en konversation",
    "searchPlaceholder": "Sök agenter efter namn, modell eller kapacitet...",
    "count_one": "{{count}} agent tillgänglig",
    "count_other": "{{count}} agenter tillgängliga",
    "loading": "Laddar agenter...",
    "error": "Kunde inte ladda agenter",
    "noAgentsFound": "Inga agenter hittades",
    "noAgentsAvailable": "Inga agenter tillgängliga",
    "adjustSearch": "Prova att justera din sökning",
    "noAgentsConfigured": "Inga AI-agenter är för närvarande konfigurerade",
    "clickToChat": "Klicka på en agent för att starta en konversation..."
  },
  "profile": {
    "title": "Profil",
    "subtitle": "Hantera dina kontoinställningar och preferenser",
    "loading": "Laddar profil...",
    "updateSuccess": "Profil uppdaterad!",
    "firstName": "Förnamn",
    "firstNamePlaceholder": "Ange förnamn",
    "lastName": "Efternamn",
    "lastNamePlaceholder": "Ange efternamn",
    "email": "E-post",
    "emailReadonly": "E-post kan inte ändras",
    "emailCannotChange": "E-post kan inte ändras. Kontakta support om du behöver uppdatera den.",
    "connectedVia": "Ansluten via {{provider}}",
    "notSet": "Ej angiven",
    "changePassword": "Ändra lösenord",
    "currentPassword": "Nuvarande lösenord",
    "currentPasswordPlaceholder": "Ange nuvarande lösenord",
    "newPassword": "Nytt lösenord",
    "newPasswordPlaceholder": "Ange nytt lösenord",
    "newPasswordHint": "Minst 8 tecken med stora och små bokstäver, siffra och specialtecken",
    "confirmPassword": "Bekräfta nytt lösenord",
    "confirmPasswordPlaceholder": "Bekräfta nytt lösenord",
    "changingPassword": "Ändrar lösenord...",
    "passwordSuccess": "Lösenord ändrat!",
    "passwordMismatch": "De nya lösenorden matchar inte",
    "passwordError": "Kunde inte ändra lösenord",
    "edit": "Redigera",
    "saveError": "Kunde inte spara ändringar. Försök igen.",
    "defaultOrganization": "Agion Platform",
    "validation": {
      "minLength": "Lösenord måste vara minst 8 tecken långt",
      "complexity": "Lösenord måste innehålla minst en siffra eller ett specialtecken"
    },
    "providers": {
      "google": "Google",
      "microsoft": "Microsoft",
      "email": "E-post och lösenord",
      "agion": "Agion"
    }
  },
  "nextPages": {
    "aboutSection": "Om {{subject}}",
    "files": {
      "actions": "Åtgärder",
      "deleteTitle": "Radera {{name}}?",
      "loadError": "Dina filer kunde inte läsas in",
      "loadErrorBody": "Dina filer kunde inte läsas. Försök igen om en stund.",
      "emptyTitle": "Inga filer ännu",
      "emptyBody": "Filer som du bifogar till en uppdragskörning visas här.",
      "moreActionsFor": "Fler åtgärder för {{name}}"
    },
    "profile": {
      "youTitle": "Du",
      "youInfo": "Ditt namn, din e-postadress och din roll i den här organisationen.",
      "role": "Roll",
      "preferencesTitle": "Inställningar",
      "preferencesInfo": "Språket som chatten använder för dig.",
      "language": "Språk",
      "languageHint": "Sparas på ditt konto, så att ditt språk följer dig mellan webbläsare.",
      "languageSaveFailed": "Ditt språk kunde inte sparas.",
      "passwordInfo": "Byt lösenordet du loggar in med. Du behöver ditt nuvarande lösenord.",
      "showPassword": "Visa lösenord",
      "hidePassword": "Dölj lösenord",
      "loadError": "Din profil kunde inte läsas in",
      "loadErrorBody": "Dina kontouppgifter kunde inte läsas. Försök igen om en stund.",
      "openedBy": {
        "title": "Vem öppnade dina konversationer",
        "info": "Personer som öppnade eller exporterade innehållet i en konversation du startade, senaste först.",
        "loading": "Läser in vem som öppnade dina konversationer…",
        "loadError": "Det gick inte att läsa in vem som öppnade dina konversationer",
        "empty": "Ingen annan har öppnat dina konversationer.",
        "showMore": "Visa fler",
        "who": "{{name}} ({{role}})",
        "formerMember": "En tidigare medlem",
        "unnamedMember": "En medlem i din organisation",
        "read": "{{who}} öppnade din konversation {{mission}} den {{date}}",
        "export": "{{who}} exporterade din konversation {{mission}} den {{date}}"
      }
    }
  }
}
